import bg from '../assets/bg.png';
import bg2 from '../assets/back-ground-lake.jpeg';

import gallery01 from '../assets/photo1.jpg';
import gallery02 from '../assets/photo2.jpg';
import gallery03 from '../assets/photo3.jpg';
import gallery04 from '../assets/photo4.jpg';
import gallery05 from '../assets/photo5.jpg';
import gallery06 from '../assets/photo6.jpg';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import quote from '../assets/quote.png';
import cafeView from '../assets/cafe-view.jpg';
import logo from '../assets/urimu.png';
import bento from '../assets/bento.jpg';
import otooka from '../assets/oto-oka.png';
import aboutUs from '../assets/about-us.jpg';
import photoGite1 from '../assets/photo-gite1.jpg';
import photoGite2 from '../assets/photo-gite2.jpg';
import photoGite3 from '../assets/photo-gite3.jpg';
import photoGite4 from '../assets/photo-gite4.jpg';
import gallery08 from '../assets/photo8.jpg';
import gallery09 from '../assets/photo9.jpg';
import nightTour from '../assets/night.jpg';
import hamburger from '../assets/hamburger.jpg';








export default {
  bg,
  bg2,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  gallery08,
  gallery09,
  photoGite1,
  photoGite2,
  photoGite3,
  photoGite4,
  overlaybg,
  spoon,
  quote,
  cafeView,
  logo,
  bento,
  otooka,
  aboutUs,
  hamburger,
  nightTour

};
